<template>
    <div class="checkpointInspectionBar">
    <div class="checkpointInspectionBarLeft">
        <CheckpointLevelBadge :level="level" />
        <StandardButton v-if="showAllInstructionIcon" size="small" leftIcon="showAllInstructionIcon" label="Show all instructions" />
        <WatchVideoButton v-if="video" @onClick="watchVideo" label="Watch Video" />
    </div>
    <div>
        <InspectionAction 
            :view="inspectionStatus"
            :isPassed="evaluationData.isPassed"
            :isFailed="evaluationData.isFailed"
            :isNotApplicable="evaluationData.isNotApplicable"
            :first_name="evaluationData.first_name"
            :last_name="evaluationData.last_name"
            :updated_on="evaluationData.updated_on"
            :updated_by="evaluationData.updated_by"
            :avatar="evaluationData.avatar"
            :failed_reason="evaluationData.failed_reason || ''"
            :not_applicable_reason="evaluationData.not_applicable_reason || ''"
            :obsolete_reason="evaluationData.obsolete_reason || ''"
            :isObsolete="evaluationData.isObsolete"
            @onPass="emit('onPass')"
            @onFail="emit('onFail')"
            @onNotApplicable="emit('onNotApplicable')"
            @onObsolete="emit('onObsolete')"
            @onClose="emit('onClose')"
        />
    </div>
    </div>
</template>

<script setup>
import CheckpointLevelBadge from "@components/CheckpointLevelBadge/CheckpointLevelBadge.vue";
import StandardButton from "@components/StandardButton/StandardButton.vue";
import WatchVideoButton from "@components/WatchVideoButton/WatchVideoButton.vue";
import InspectionAction from "@components/InspectionAction/InspectionAction.vue";

const emit = defineEmits(['watchVideo', 'onPass', 'onFail', 'onNotApplicable', 'onObsolete', 'onClose']);

const props = defineProps({
    level: {
        type: String,
        required: true,
    },
    instructions: {
        type: String,
        required: true,
    },
    video: {
        type: String,
        default: null,
    },
    showAllInstructionIcon: {
        type: Boolean,
        required: true,
    },
    inspectionStatus: {
        type: String,
        default: "pending-evaluation",
    },
    evaluationData: {
        type: Object,
        default: () => ({
            isPassed: false,
            isFailed: false,
            isNotApplicable: false,
            isObsolete: false,
            first_name: "",
            last_name: "",
            updated_on: "",
            updated_by: {},
            avatar: "",
            failed_reason: "",
            not_applicable_reason: "",
            obsolete_reason: "",
            reset_reason: "",
        }),
    },
});

const watchVideo = () => {
    if (!props.video) return;
    emit('watchVideo', props.video);
};
</script>

<style scoped>
.checkpointInspectionBar {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
}

.checkpointInspectionBarLeft {
    display: flex;
    align-items: start;
    gap: 7px;
}

::v-deep(.ex-checkpoint-badge .v-chip) {
    padding: 16px 32px !important;
}

::v-deep(.standard-button) {
    height: 32px !important;
}

::v-deep(.watch-video, .watch-video:hover) {
    padding: 0px !important;
    margin: 0px !important;
}

::v-deep(.pass-fail-buttons) {
    margin-top: 0px !important;
}

::v-deep(.evaluation) {
    margin-top: 0px !important;
}

::v-deep(.evaluation-evaluation) {
    margin-top: 0px !important;
}
</style>